const CALENDAR_UI_STATE_PREFIX = 'new-calendar-ui-state:';
const CALENDAR_RETURN_CONTEXT_KEY = 'new-calendar-return-context';

function getSessionStorage() {
  if (typeof window === 'undefined') return null;

  try {
    return window.sessionStorage;
  } catch (_error) {
    return null;
  }
}

function readJson(key) {
  const storage = getSessionStorage();
  if (!storage) return null;

  try {
    const value = storage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (_error) {
    return null;
  }
}

function writeJson(key, value) {
  const storage = getSessionStorage();
  if (!storage) return;

  try {
    storage.setItem(key, JSON.stringify(value));
  } catch (_error) {
    // Calendar navigation must keep working when storage is unavailable or full.
  }
}

function normalizePath(pathname) {
  const value = String(pathname || '').trim();
  if (!value) return '/calendar';
  return value.length > 1 ? value.replace(/\/+$/, '') : value;
}

function getCalendarUiStateKey(pathname) {
  return `${CALENDAR_UI_STATE_PREFIX}${normalizePath(pathname)}`;
}

export function readCalendarUiState(pathname) {
  const value = readJson(getCalendarUiStateKey(pathname));
  return value && typeof value === 'object' ? value : null;
}

export function saveCalendarUiState(pathname, state) {
  writeJson(getCalendarUiStateKey(pathname), state);
}

export function saveCalendarReturnContext(context) {
  if (!context?.sourcePath || !context?.task) return;

  writeJson(CALENDAR_RETURN_CONTEXT_KEY, {
    ...context,
    sourcePath: normalizePath(context.sourcePath),
  });
}

export function consumeCalendarReturnContext(pathname) {
  const storage = getSessionStorage();
  if (!storage) return null;

  const context = readJson(CALENDAR_RETURN_CONTEXT_KEY);
  if (!context || normalizePath(context.sourcePath) !== normalizePath(pathname)) return null;

  try {
    storage.removeItem(CALENDAR_RETURN_CONTEXT_KEY);
  } catch (_error) {
    // The restored in-memory context is still safe to use.
  }

  return context;
}
